import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CategoryImages = () => {
    const scrollRef = useRef(null);
    const navigate = useNavigate();
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    // const categories = [
    //     { name: 'Electronics', image: 'https://picsum.photos/seed/electronics/200/200', path: '/category-detail' },
    //     { name: 'Clothing', image: 'https://picsum.photos/seed/clothing/200/200', path: '/category-detail' },
    //     { name: 'Books', image: 'https://picsum.photos/seed/books/200/200', path: '/category-detail' },
    //     { name: 'Home Decor', image: 'https://picsum.photos/seed/homedecor/200/200', path: '/category-detail' },
    //     { name: 'Toys', image: 'https://picsum.photos/seed/toys/200/200', path: '/category-detail' },
    //     { name: 'Sports', image: 'https://picsum.photos/seed/sports/200/200', path: '/category-detail' },
    //     { name: 'Electronics', image: 'https://picsum.photos/seed/electronics2/200/200', path: '/category-detail' },
    //     { name: 'Clothing', image: 'https://picsum.photos/seed/clothing2/200/200', path: '/category-detail' },
    //     { name: 'Books', image: 'https://picsum.photos/seed/books2/200/200', path: '/category-detail' },
    //     { name: 'Home Decor', image: 'https://picsum.photos/seed/homedecor2/200/200', path: '/category-detail' },
    //     { name: 'Toys', image: 'https://picsum.photos/seed/toys2/200/200', path: '/category-detail' },
    // ];

    const url = process.env.REACT_APP_API_URL
    const [categories, setCategories] = useState([]);

    const updateScrollVisibility = () => {
        const el = scrollRef.current;
        if (el) {
            setCanScrollLeft(el.scrollLeft > 0);
            setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
        }
    };

    useEffect(() => {
        updateScrollVisibility();
        const el = scrollRef.current;
        if (el) {
            el.addEventListener('scroll', updateScrollVisibility);
        }
        window.addEventListener('resize', updateScrollVisibility);
        return () => {
            if (el) el.removeEventListener('scroll', updateScrollVisibility);
            window.removeEventListener('resize', updateScrollVisibility);
        };
    }, []);

    const handleScrollRight = () => {
        scrollRef.current?.scrollBy({ left: 150, behavior: 'smooth' });
    };

    const handleScrollLeft = () => {
        scrollRef.current?.scrollBy({ left: -150, behavior: 'smooth' });
    };

    const handleCategoryClick = (cat) => {
        navigate(`/category-detail/${cat}`);
    };

    const fetchCategory = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${process.env.REACT_APP_PERFUME_ID}`, {
                method: "GET",
            });
            const res = await response.json();

            // Filter by status and sort by position (as number)
            const activeCategories = res
                .filter(cat => cat.status === "Active")
                .sort((a, b) => Number(a.position) - Number(b.position));

            setCategories(activeCategories);
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        fetchCategory();
    }, [])

    useEffect(() => {
        setTimeout(updateScrollVisibility, 100); 
    }, [categories]);


    return (
        <>
            {
                categories.length > 0 && <section className="category-images-section">
                    <div className="section-images-heading">
                        <h2>Discover Our Categories</h2>
                        <p>Handpicked selections to elevate your lifestyle</p>
                    </div>

                    <div className="scroll-container-wrapper">
                        {canScrollLeft && (
                            <div
                                className="category-images-scroll-chevron category-images-scroll-chevron-left"
                                onClick={handleScrollLeft}
                            >
                                <i className="fas fa-chevron-left"></i>
                            </div>
                        )}

                        <div className="product-scroll-wrapper" ref={scrollRef}>
                            {categories.map((category, index) => (
                                <div
                                    key={index}
                                    className="category-images-card"
                                    onClick={() => handleCategoryClick(category.category)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <img src={`${category.icon}`} alt={category.name} />
                                    <h4>{category.category}</h4>
                                </div>
                            ))}
                        </div>

                        {canScrollRight && (
                            <div
                                className="category-images-scroll-chevron category-images-scroll-chevron-right"
                                onClick={handleScrollRight}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </div>
                        )}
                    </div>
                </section>
            }
        </>
    );
};

export default CategoryImages;
